import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRIcon } from 'src/app/models/qr-icon.model';

@Component({
  selector: 'qr-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() config!: QRButton;
  @Input() isDisabled?: boolean = false;
  @Input() isLoading?: boolean = false;
  /** Used with config.loaderOnlyWhenSubmitReady (movement add dialogs). */
  @Input() isSubmitReady = true;
  iconColor: string = '';
  sizeSmall = QRButton.SIZE_SMALL;

  /**
   * Hierarchies with a shimmer variant in Figma (colors live in the scss).
   * Anything else falls back to the spinner loader.
   */
  private static readonly SHIMMER_HIERARCHIES: string[] = [
    QRButton.HIERARCHY_1,
    QRButton.HIERARCHY_LIGHT,
    QRButton.HIERARCHY_3,
    QRButton.HIERARCHY_5,
  ];

  /** True when loader UI (shimmer or spinner) should be visible. */
  get isLoaderVisible(): boolean {
    if (!this.isLoading) {
      return false;
    }
    if (this.config?.loaderOnlyWhenSubmitReady && !this.isSubmitReady) {
      return false;
    }
    return true;
  }

  /**
   * True when the button must render the opt-in shimmer loader, which keeps the
   * label visible and grows a gradient overlay (Figma loader) instead of swapping content.
   */
  @HostBinding('class.is-loading-shimmer')
  get isShimmerLoading(): boolean {
    return (
      this.isLoaderVisible &&
      !this.isDisabled &&
      !!this.config &&
      this.config.loader === QRButton.LOADER_SHIMMER &&
      !this.config.iconOnly &&
      ButtonComponent.SHIMMER_HIERARCHIES.indexOf(this.config.hierarchy) !== -1
    );
  }

  ngOnInit(): void {
    this.configIconColor();
  }

  ngOnChanges() {
    this.configIconColor();
  }

  configIconColor(): void {
    if (!this.isDisabled) {
      switch (this.config.hierarchy) {
        case QRButton.HIERARCHY_1:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
        case QRButton.HIERARCHY_LIGHT:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
        case QRButton.HIERARCHY_2:
          this.iconColor = QRIcon.COLOR_PRIMARY_700;
          break;
        case QRButton.HIERARCHY_3:
          this.iconColor = QRIcon.COLOR_GREY_700;
          break; 
        case QRButton.HIERARCHY_4:
          this.iconColor = QRIcon.COLOR_GREY_700;
          break;
        case QRButton.HIERARCHY_5:
          this.iconColor = QRIcon.COLOR_GREY_700;
          break;
        case QRButton.HIERARCHY_WHATSAPP_1:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
        case QRButton.HIERARCHY_ERROR:
          this.iconColor = QRIcon.COLOR_ERROR_900;
          break;
      }
    } else {
      switch (this.config.hierarchy) {
        case QRButton.HIERARCHY_1:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
        case QRButton.HIERARCHY_LIGHT:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
        case QRButton.HIERARCHY_2:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
        case QRButton.HIERARCHY_3:
          this.iconColor = QRIcon.COLOR_GREY_300;
          break;
        case QRButton.HIERARCHY_4:
          this.iconColor = QRIcon.COLOR_GREY_300;
          break;
        case QRButton.HIERARCHY_5:
          this.iconColor = QRIcon.COLOR_GREY_300;
          break;
        case QRButton.HIERARCHY_WHATSAPP_1:
          this.iconColor = QRIcon.COLOR_WHITE;
          break;
      }
    }
  }
}
